import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { ConfigurationsGroup } from './models/configuration';

@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.less'],
})
export class ManagementComponent extends BaseComponent implements OnInit {
  configurationGroups: ConfigurationsGroup[] = [];
  constructor(injector: Injector) {
    super(injector);
    this.layoutService.pageTitle.next('Management');
  }
  selectedLanguage: string = 'en';
  ngOnInit() {
    this.selectedLanguage = localStorage.getItem('app_lang') || 'en';
    this.configurationService.getAll().subscribe((response) => {
      this.configurationGroups = response;

      if (this.configurationGroups.find(c => c.code == 'general') == null) {
        this.configurationGroups.push({
          code: 'general',
          name: 'General Configuration',
          objectType: 9,
          position: 0,
          translations: [],
          configurations: [{
            code: 'decimal_seperator',
            descibtion: 'Decimal Seperator',
            type: "1"
          }]
        });
      }
    });
  }
  changeLanguage(lang: string) {
    localStorage.setItem('app_lang', lang);
    this.languageService.setLanguage(lang);
  }
}
